module.exports = __webpack_public_path__ + "static/img/2_2.ca4b0f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/2_2.png
// module id = XK3U
// module chunks = 0